import * as BackgroundFetch from 'expo-background-task';
import ky from 'ky';

import {
  defineBackgroundTask,
  calendarSyncBackgroundTask,
  ApiConnector,
  loadApplets,
  AuthResponse,
  cacheService,
  authCacheKey,
  initApplets,
  AppletUpdateReasons,
  calendarService,
  syncCalendarEvents,
} from '@medad-sep/core';

import {appletsList} from '../../config/applets-list';
import {config} from '../../config/env';

const {baseApiUrl, tenant} = config;

export function initSyncCalendarEvents() {
  defineBackgroundTask(calendarSyncBackgroundTask, async () => {
    try {
      const {connectors} = await ky
        .get('connector-manager/connectors', {
          prefixUrl: baseApiUrl,
          headers: {'x-tenant': tenant},
        })
        .json<{connectors: ApiConnector[]}>();

      const applets = await loadApplets(appletsList, connectors);

      const userAuthInfo: AuthResponse | undefined = await cacheService.get(authCacheKey);

      if (!userAuthInfo) return BackgroundFetch.BackgroundTaskResult.Failed;

      try {
        await initApplets(
          applets,
          connectors,
          true,
          userAuthInfo.accessToken,
          tenant,
          AppletUpdateReasons.UPDATE_CALENDAR,
        );
      } catch (error) {
        return BackgroundFetch.BackgroundTaskResult.Failed;
      }

      const calendarEvents = calendarService.getEvents();

      if (calendarEvents.length) {
        syncCalendarEvents(calendarEvents);
      }

      return BackgroundFetch.BackgroundTaskResult.Success;
    } catch (error) {
      return BackgroundFetch.BackgroundTaskResult.Failed;
    }
  });
}
